var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"chartElm",staticClass:"chart-js",attrs:{"height":_vm.height,"width":_vm.width},on:{"wheel":_vm.emitWheel}})}
var staticRenderFns = []

export { render, staticRenderFns }